// @flow
import React, { type Node } from 'react';
import classNames from 'classnames';

type Props = {|
  htmlFor: string,
  label: string,
  children?: Node,
  isOptional?: boolean,
  /** Available sizes: 'small'. */
  size?: 'small' | void,
  visible?: boolean,
  inline?: boolean,
|};

const Label = ({
  htmlFor,
  label,
  size,
  children,
  visible,
  inline,
  isOptional,
}: Props) => {
  const className = classNames('c-form-element__label', {
    'c-form-element__label--size-small': size === 'small',
    'c-form-element__label--inline': inline === true,
    'u-hide-visually': !visible,
  });

  return (
    <label className={className} htmlFor={htmlFor}>
      {label}
      {isOptional && (
        <span className="c-form-element__optional-label"> (optional)</span>
      )}
      {children}
    </label>
  );
};

Label.defaultProps = {
  visible: true,
  isOptional: false,
  inline: false,
};

export default Label;
